import PropTypes from "prop-types";
import { connect } from "react-redux";
import { storesReady } from "redux-store";
import { createPromiseApiAction } from "redux-store/api-sagas";
import {
  FETCH_VERSIONS,
  versionsUnloadAction,
} from "redux-store/ui-state/versions/actions";
import { versionsSelector } from "redux-store/ui-state/versions/selectors";
import { FetchController } from "ui/fetch/fetch-controller";

function mapStateToProps(state, props) {
  const objectLoaded = storesReady(state.pages.versions);

  return {
    objectLoaded,
    injectAs: "versions",
    object: versionsSelector(state),
    objectId: props.fetchId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchObject: (_fetchId, params, options) => {
      const serviceArgs = [params, options];

      return createPromiseApiAction(dispatch, FETCH_VERSIONS, serviceArgs);
    },
    unloadObject: () => {
      dispatch(versionsUnloadAction);
    },
  };
}

const ConnectedFetchVersionsController = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FetchController);

ConnectedFetchVersionsController.propTypes = {
  fetchId: PropTypes.string.isRequired,
};

export { ConnectedFetchVersionsController };
